<template>
  <span 
    :class="badgeClasses"
    :title="tooltipText"
  >
    <i 
      v-if="icon"
      :class="icon" 
      aria-hidden="true"
    ></i>
    {{ displayText }}
    <i 
      v-if="showInfo && shouldShowInfo"
      class="fas fa-info-circle ml-1 pointer"
      @click="onInfoClick"
    ></i>
  </span>
</template>

<script>
export default {
  name: 'StatusBadge',
  
  props: {
    value: {
      type: [String, Object],
      required: true
    },
    row: {
      type: Object,
      default: () => ({})
    },
    showInfo: {
      type: Boolean,
      default: false
    },
    infoCondition: {
      type: Function,
      default: null
    },
    statusMap: {
      type: Object,
      default: () => ({
        'Draft': { variant: 'secondary', icon: 'fas fa-edit' },
        'OnHold': { variant: 'warning', icon: 'fas fa-pause' },
        'Committed': { variant: 'success', icon: 'fas fa-check' },
        'Cancelled': { variant: 'danger', icon: 'fas fa-times' },
        'Billed': { variant: 'info', icon: 'fas fa-file-invoice' }
      })
    }
  },

  computed: {
    statusKey() {
      return typeof this.value === 'object' ? this.value.status : this.value
    },

    statusConfig() {
      return this.statusMap[this.statusKey] || { 
        variant: 'secondary', 
        icon: null 
      }
    },

    badgeClasses() {
      return [
        'badge',
        `badge-${this.statusConfig.variant}`,
        this.statusConfig.pill ? 'badge-pill' : '',
        'd-inline-flex',
        'align-items-center'
      ].filter(Boolean)
    },

    displayText() {
      // Use your existing splitString filter
      return this.$options.filters.splitString(this.statusKey) || this.statusKey
    },

    icon() {
      return this.statusConfig.icon
    },

    shouldShowInfo() {
      if (this.infoCondition && typeof this.infoCondition === 'function') {
        return this.infoCondition(this.row)
      }
      return this.statusKey === 'OnHold'
    },

    tooltipText() {
      return `Status: ${this.displayText}`
    }
  },

  methods: {
    onInfoClick() {
      this.$emit('info-click', {
        status: this.statusKey,
        row: this.row
      })
    }
  }
}
</script>

<style scoped>
.badge {
  gap: 0.25rem;
  font-size: 0.85rem;
  font-weight: 500;
  padding: 0.35em 0.75em;
}

.pointer {
  cursor: pointer;
}

.badge i {
  font-size: 0.85em;
}

/* Soft pastel variants */
.badge-soft-success {
  background-color: rgba(40, 167, 69, 0.15);
  color: #1e7e34;
  border: none;
}

.badge-soft-warning {
  background-color: rgba(255, 168, 0, 0.18);
  color: #c87000;
  border: none;
}

.badge-soft-secondary {
  background-color: rgba(108, 117, 125, 0.14);
  color: #495057;
  border: none;
}
</style>